import { useEffect, useRef, useState } from 'react';
import { FaCommentDots, FaChevronDown } from 'react-icons/fa';
import '../LandingPage.css';

// Hardcoded chat URL as per PRD
const CHAT_URL = '/chat/55956052-c400-46f0-9234-6265b7bfdd6b';

function ChatWidget() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  // The iframe is only mounted on first open (it fetches a greeting), then
  // kept mounted so the conversation survives minimising.
  const [hasOpenedChat, setHasOpenedChat] = useState(false);
  const launcherRef = useRef<HTMLButtonElement>(null);
  const minimizeRef = useRef<HTMLButtonElement>(null);
  const wasOpen = useRef(false);

  const openChat = () => {
    setHasOpenedChat(true);
    setIsChatOpen(true);
  };

  const minimizeChat = () => setIsChatOpen(false);

  // Move focus into the panel on open and back to the launcher on minimise.
  useEffect(() => {
    if (isChatOpen) {
      minimizeRef.current?.focus();
    } else if (wasOpen.current) {
      launcherRef.current?.focus();
    }
    wasOpen.current = isChatOpen;
  }, [isChatOpen]);

  useEffect(() => {
    if (!isChatOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsChatOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isChatOpen]);

  return (
    <>
      <button
        ref={launcherRef}
        className={`chat-widget-icon ${isChatOpen ? 'chat-widget-icon--hidden' : ''}`}
        onClick={openChat}
        aria-label="Open chat with EFSoft"
        aria-expanded={isChatOpen}
        aria-controls="chat-widget-window"
      >
        <FaCommentDots size={24} aria-hidden="true" />
      </button>

      <div
        id="chat-widget-window"
        className={`chat-widget-window ${!isChatOpen ? 'chat-widget-window--hidden' : ''}`}
        role="dialog"
        aria-labelledby="chat-widget-title"
      >
        <div className="chat-widget-header">
          <span id="chat-widget-title">Chat with EFSoft</span>
          <button
            ref={minimizeRef}
            className="chat-widget-minimize-button"
            onClick={minimizeChat}
            aria-label="Minimise chat"
            title="Minimise chat"
          >
            <FaChevronDown size={18} aria-hidden="true" />
          </button>
        </div>
        <div className="chat-widget-content">
          {hasOpenedChat && (
            <iframe
              src={CHAT_URL}
              className="chat-widget-iframe"
              title="EFSoft chat"
            />
          )}
        </div>
      </div>
    </>
  );
}

export default ChatWidget;
